export default __webpack_public_path__ + "static/media/RMPS.64aa64f2.png";